var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"floating-button",style:({ left: _vm.left + 'px', top: _vm.top + 'px' }),on:{"mousedown":_vm.startDragging,"mouseup":_vm.stopDragging,"mouseleave":_vm.stopDragging}},[_c('svg-icon',{attrs:{"icon-class":"Assistant","className":"icon-assistant"},on:{"dblclick":_vm.openDrawer}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }